export default __webpack_public_path__ + "static/media/EM0160.34I-23604_-15368_0.9f7b39d4.jpg";